import { DownloadOutlined } from '@ant-design/icons';
import { ProColumns } from '@ant-design/pro-components';
import { Button, Input, Select, Table } from 'antd';
import CustomSelect from 'base/ui/components/CustomSelect';
import CustomProTable from 'base/ui/components/CustomTable';
import { observer } from 'mobx-react';
import { useCallback, useEffect, useState } from 'react';
import { BsFillPlusSquareFill } from 'react-icons/bs';
import { HiSearch } from 'react-icons/hi';
import { DropdownEquipment } from 'services/commonDate_services';
import { DataInputRouting, RoutingModel } from 'services/routing_services';
import { commonDatePresenter, commonDateStore, routingPresenter, routingStore } from 'stores/root_store';
import { DataSearchRouting } from './model';
import { ColumnType } from 'antd/es/table';
import { GrEdit } from 'react-icons/gr';
import { useNavigate } from 'react-router-dom';
import { PAGE_SIZE_DEFAULT } from 'utils/constants';
import { FaCheck } from 'react-icons/fa';
import { MdOutlineClose } from 'react-icons/md';
import { debounce } from '@mui/material';
import { ListKeynValue } from 'services/report_services';
import moment from 'moment';
import { getUserSession } from 'utils/localStorageHelper';
import { User } from 'services/user_services';
const statusConstant = [
  {
    key: 1,
    label: 'Đang sử dụng',
    value: true,
  },
  {
    key: 2,
    label: 'Ngưng sử dụng',
    value: false,
  },
];
const createRoutingOrTransfer = () => {
  return observer(() => {
    const navigate = useNavigate();
    // Loading all page
    const [loading, setLoading] = useState(false);
    // List dropdown routing
    const [listRouting, setListRouting] = useState<RoutingModel[]>([]);
    // Load equipment
    const [listEquipment, setListEquipment] = useState<DropdownEquipment[]>([]);
    // List data routing
    const [listDataRouting, setListDataRouting] = useState<DataInputRouting[]>([]);

    // ===============================PHÂN QUYỀN==================================
    // chỉnh sửa
    const [isEdit, setIsEdit] = useState(false);
    // Tạo mới
    const [isCreate, setIsCreate] = useState(false);
    // Export
    const [isExport, setIsExport] = useState(false);

    // Data search
    const [dataSearch, setDataSearch] = useState({
      paging: {
        pageIndex: 1,
        pageSize: PAGE_SIZE_DEFAULT,
        orderBy: '',
        orderByDesc: '',
      },
      stepCode: undefined as string | undefined,
      stepName: undefined as string | undefined,
      equipmentList: [] as string[],
      actived: undefined as boolean | undefined,
    });
    // Columns table title
    const defaultColumn: ProColumns<DataInputRouting>[] = [
      {
        title: 'STT',
        dataIndex: 'stt',
        width: 50,
        key: 'stt',
        className: '!rounded-none !py-1',
        render: (text) => <div className="!text-center">{text}</div>,
      },
      {
        title: 'Mã công đoạn',
        dataIndex: 'stepCode',
        width: 150,
        key: 'stepCode',
        sorter: true,
        className: '!rounded-none !py-1',
      },
      {
        title: 'Tên công đoạn',
        dataIndex: 'stepName',
        width: 200,
        key: 'stepName',
        sorter: true,
        className: '!rounded-none !py-1',
      },
      {
        title: 'Mã máy/chuyền',
        dataIndex: 'equipmentCode',
        width: 130,
        key: 'equipmentCode',
        sorter: true,
        className: '!rounded-none !py-1',
        render: (text, record) => {
          return {
            props: {
              style: {
                textAlign: 'left',
              },
            },
            children: text !== null && text !== '-' ? text : '',
          };
        },
      },
      {
        title: 'Tên máy/chuyền',
        dataIndex: 'equipmentName',
        width: 300,
        key: 'equipmentName',
        sorter: true,
        className: '!rounded-none !py-1',
        render: (text, record) => {
          return {
            props: {
              style: {
                textAlign: 'left',
              },
            },
            children: text !== null && text !== '-' ? text : '',
          };
        },
      },
      {
        title: 'Mô tả',
        dataIndex: 'description',
        width: 300,
        key: 'description',
        sorter: true,
        className: '!rounded-none !py-1',
        render: (text, record) => {
          return {
            props: {
              style: {
                textAlign: 'left',
              },
            },
            children: text !== null && text !== '-' ? text : '',
          };
        },
      },
      {
        title: 'Công suất/chuyền',
        dataIndex: 'equipmentProduction',
        width: 150,
        key: 'equipmentProduction',
        sorter: true,
        className: '!rounded-none !py-1',
        render: (text) => <div className="!text-right">{text}</div>,
      },
      {
        title: 'Đơn vị tính công suất',
        dataIndex: 'unit',
        width: 170,
        key: 'unit',
        sorter: true,
        className: '!rounded-none !py-1',
        render: (text, record) => {
          return {
            props: {
              style: {
                textAlign: 'left',
              },
            },
            children: text !== null && text !== '-' ? text : '',
          };
        },
      },
      {
        title: 'Work center Internal ID',
        dataIndex: 'workCenterInternalID',
        width: 170,
        key: 'workCenterInternalID',
        className: '!rounded-none !py-1',
      },
      {
        title: 'Tên Workcenter',
        dataIndex: 'workCenterName',
        width: 170,
        key: 'workCenterName',
        className: '!rounded-none !py-1',
      },
      {
        title: 'Người tạo',
        dataIndex: 'createBy',
        width: 200,
        key: 'createBy',
        sorter: true,
        className: '!rounded-none !py-1',
        render: (text, record) => {
          return {
            props: {
              style: {
                textAlign: 'left',
              },
            },
            children: text !== null && text !== '-' ? text : '',
          };
        },
      },
      {
        title: 'Ngày tạo',
        dataIndex: 'createTime',
        width: 150,
        key: 'createTime',
        sorter: true,
        className: '!rounded-none !py-1',
        render(_, record) {
          return <>{record.createTime ? moment(record.createTime).format('DD/MM/YYYY HH:mm') : ''}</>;
        },
        onCell: (text, record) => ({
          style: {
            textAlign: 'center',
          },
        }),
      },
      {
        title: 'Trạng thái',
        dataIndex: 'actived',
        width: 100,
        key: 'actived',
        sorter: true,
        className: '!rounded-none !py-1',
        render: (_, record) => {
          return (
            <div>
              {record.actived ? (
                <FaCheck className="text-blue-700 text-lg text-center mx-auto" />
              ) : (
                <MdOutlineClose className="text-red-800 font-extrabold text-[24px] mx-auto" />
              )}
            </div>
          );
        },
      },
      {
        title: 'Chức năng',
        dataIndex: 'function',
        width: 100,
        key: 'function',
        className: '!rounded-none !py-1',
        render: (_, record) => {
          return (
            <div className="w-full flex items-center justify-center">
              {isEdit ? (
                <button
                  className=" text-default bg-btn_edit py-0.25 px-2.5 rounded-sm border-border_input border flex gap-1 items-center justify-center"
                  onClick={() => navigate(`/MasterData/Routing/Edit/${record.stepId}`)}
                >
                  <GrEdit />
                  Sửa
                </button>
              ) : (
                ''
              )}
            </div>
          );
        },
      },
    ];

    // Custom default columns table with resizeable
    const [columns, setColumn] = useState<ProColumns<DataInputRouting>[]>(defaultColumn);

    // Function handle resize columns
    const handleResize =
      (index: number) =>
        (e: any, { size }: any) => {
          // Set columns
          setColumn((prevColumns) => {
            const nextColumns = [...prevColumns];
            nextColumns[index] = {
              ...nextColumns[index],
              width: size.width,
            };
            return nextColumns;
          });
        };

    // Call api get list routing
    const getDropDownRouting = async (keyWord: string) => {
      await routingPresenter.getListRouting(routingStore, keyWord);
      setListRouting(routingStore.routing.data);
    };

    const searchRouting = useCallback(debounce(getDropDownRouting, 300), [])

    // Call api list dropdown equipment
    const getListDropdownEquipment = async (keyword = '') => {
      await commonDatePresenter.getDropdownEquipment(commonDateStore, keyword);
      if (commonDateStore.dropdownEquipment.isSuccess) {
        setListEquipment(commonDateStore.dropdownEquipment.data);
      }
    };

    // Call api search routing
    const getDataSearchRouting = async (dataSearch: DataSearchRouting) => {
      await routingPresenter.searchRouting(routingStore, dataSearch);
      if (routingStore.searchRoutingResponse.isSuccess) {
        setListDataRouting(routingStore.searchRoutingResponse.data);
      }
    };

    // Change select routing item
    const handleChangeSelect = async (value: any, option: RoutingModel, idKey: string) => {
      if (option && !Array.isArray(option)) {
        setDataSearch({ ...dataSearch, [idKey]: option.stepCode });
      } else {
        setDataSearch({ ...dataSearch, [idKey]: '' });
      }
    };

    // Change value search input
    const handleChangeSearchValue = (e: React.ChangeEvent<HTMLInputElement>) => {
      setDataSearch({
        ...dataSearch,
        stepName: e.target.value,
      });
    };

    // Change select multiple item
    const handleChangeSelectMul = async (value: any, option: ListKeynValue, idKey: string) => {
      if (option && Array.isArray(option)) {
        setDataSearch({ ...dataSearch, [idKey]: option.map((i) => i.key) });
      } else {
        setDataSearch({ ...dataSearch, [idKey]: undefined });
      }
    };

    // Change select status item
    const handleChangeSelectStatus = async (value: any, option: ListKeynValue, idKey: string) => {
      if (option && !Array.isArray(option)) {
        setDataSearch({ ...dataSearch, [idKey]: option.value });
      } else {
        setDataSearch({ ...dataSearch, [idKey]: null });
      }
    };

    const pagePermissions = () => {
      // Kiểm tra đường dẫn
      // check phân quyền bằng đường dẫn
      // kiểm tra url của web để tìm page id => dùng page id để tìm quyền của trang
      const path = window.location.pathname;
      const user = getUserSession() as User;
      const filteredData = user.webPermission.pageModel.filter((item) => {
        const itemNames = item.pageUrl.split(' ');
        return itemNames.some((name) => path.includes(name));
      });
      if (filteredData.length) {
        const permission = user.webPermission.pagePermissionModel.filter(
          (item) => item.pageId === filteredData[0].pageId,
        );
        if (permission.length) {
          if (permission.findIndex((item) => item.functionId === 'EDIT') > -1) {
            setIsEdit(true);
          }
          if (permission.findIndex((item) => item.functionId === 'EXPORT') > -1) {
            setIsExport(true);
          }
          if (permission.findIndex((item) => item.functionId === 'CREATE') > -1) {
            setIsCreate(true);
          }
        }
      }
    };

    useEffect(() => {
      setColumn(defaultColumn);
    }, [isEdit]);

    // Load data first
    useEffect(() => {
      // Loading khi call api
      setLoading(true);
      pagePermissions();

      getDropDownRouting('');
      getListDropdownEquipment();
    }, []);

    // Handle click button search
    const handleSearch = debounce(async () => {
      setLoading(true);
      const tempDataSearch = {
        ...dataSearch,
        paging: {
          ...dataSearch.paging,
          pageIndex: 1,
        },
      };
      await getDataSearchRouting(tempDataSearch);
      setLoading(false);
    }, 300);

    return (
      <>
        <div className="w-full py-3 px-5">
          {/* Header */}
          <div className="mb-2 flex justify-between items-center">
            <div className="flex items-center">
              <h3 className="text-md font-bold text-gray-800 uppercase">Danh mục công đoạn/chuyền</h3>
            </div>

            <div className="flex space-x-2">
              {isCreate ? (
                <Button
                  className="!flex !items-center !text-white !bg-[#0052cc] hover:!bg-blue-600 !border-[#0052cc] !rounded-[3px] !text-default font-[400] !px-2.5 !py-1 text-center !h-7"
                  icon={<BsFillPlusSquareFill />}
                  onClick={() => {
                    navigate('/MasterData/Routing/Create');
                  }}
                >
                  Thêm mới
                </Button>
              ) : (
                ''
              )}
              {isExport ? (
                <Button
                  className="!flex !items-center !text-white !bg-[#0052cc] hover:!bg-blue-600 !border-[#0052cc] !rounded-[3px] !text-default font-[400] !px-2.5 !py-1 text-center !h-7"
                  icon={<DownloadOutlined />}
                  loading={loading}
                  onClick={async () => {
                    setLoading(true);
                    await routingPresenter.exportRouting({ ...dataSearch });
                    setLoading(false);
                  }}
                >
                  Export
                </Button>
              ) : (
                ''
              )}
            </div>
          </div>

          {/* Form nhập tìm kiếm */}
          <div className={`w-full bg-white border-neutral-300 flex overflow-hidden duration-700 relative mb-2 rounded`}>
            <form className={`w-full px-8 py-2 lg:grid lg:grid-cols-2 flex flex-col gap-y-2`}>
              {/* Mã công đoạn */}
              <div className="w-full sm:items-center grid grid-cols-3">
                <CustomSelect
                  title="Mã công đoạn"
                  data={listRouting}
                  fieldNames={{ label: 'stepName', value: 'stepCode' }}
                  onChangeValue={handleChangeSelect}
                  idKey="stepCode"
                  showSearch
                  optionFilterProp="children"
                  filterOption={false}
                  onSearch={(value) => searchRouting(value)}
                  allowClear
                  placeholder="--Tất cả--"
                />
              </div>
              {/* Tên công đoạn */}
              <div className="w-full sm:flex-row sm:items-center grid grid-cols-3">
                <label className="min-w-[150px] font-bold text-default text-black sm:text-end sm:!mr-5">
                  Tên công đoạn
                </label>
                <div className='sm:!ml-5 col-span-2'>
                  <Input
                    className="w-full text-gray-700 !text-default [&_span]:!text-default !rounded-none border-border_input focus-visible:outline-none"
                    onChange={handleChangeSearchValue}
                  />
                </div>
              </div>
              {/* Máy móc/chuyền */}
              <div className="w-full sm:flex-row sm:items-center grid grid-cols-3">
                <CustomSelect
                  mode="multiple"
                  title="Máy móc/chuyền"
                  data={listEquipment}
                  onChangeValue={handleChangeSelectMul}
                  idKey="equipmentList"
                  showSearch
                  allowClear
                />
              </div>
              {/* Trạng thái */}
              <div className="w-full sm:flex-row sm:items-center grid grid-cols-3 sm:[&_label]:!mr-5">
                <CustomSelect
                  className="col-span-2"
                  title="Trạng thái"
                  data={statusConstant}
                  onChangeValue={handleChangeSelectStatus}
                  idKey="actived"
                  allowClear
                  placeholder="--Tất cả--"
                />
              </div>

              {/* Button tìm kiếm */}
              <div className="w-full flex justify-center col-span-2">
                <Button
                  className="!flex !items-center !text-white !bg-[#0052cc] hover:!bg-blue-600 !border-[#0052cc] !rounded-[3px] !text-default font-[400] !px-2.5 !py-1 text-center !h-7"
                  icon={<HiSearch />}
                  onClick={handleSearch}
                >
                  Tìm kiếm
                </Button>
              </div>
            </form>
          </div>
          {/* Table */}
          <div className="w-full mt-3 bg-white py-3 flex rounded mb-2 p-2 border border-neutral-300 lg:flex-row sm:flex-col md:flex-col  flex-col">
            <div className={`w-full overflow-y-hidden tableContainer`}>
              <CustomProTable<DataInputRouting>
                columns={columns}
                handleResize={handleResize}
                rowKey="stepId"
                bordered
                options={false}
                search={false}
                size="small"
                request={async (params = {}, sort, filter) => {
                  setLoading(true);
                  const data: any = await getDataSearchRouting({
                    ...dataSearch,
                    paging: {
                      ...dataSearch.paging,
                      orderBy: Object.values(sort)[0] === 'ascend' ? `${Object.keys(sort)[0].split(',').pop()}` : '',
                      orderByDesc:
                        Object.values(sort)[0] === 'descend' ? `${Object.keys(sort)[0].split(',').pop()}` : '',
                    },
                  });

                  if (Object.values(sort).length) {
                    setDataSearch({
                      ...dataSearch,
                      paging: {
                        ...dataSearch.paging,
                        orderBy: Object.values(sort)[0] === 'ascend' ? `${Object.keys(sort)[0].split(',').pop()}` : '',
                        orderByDesc:
                          Object.values(sort)[0] === 'descend' ? `${Object.keys(sort)[0].split(',').pop()}` : '',
                      },
                    });
                  }

                  setLoading(false);

                  return {
                    data: data,
                    success: routingStore.searchRoutingResponse.isSuccess,
                  };
                }}
                dataSource={listDataRouting}
                scroll={{ x: 1550, y: 500 }}
                pagination={{
                  pageSize: dataSearch.paging.pageSize,
                  total: routingStore.searchRoutingResponse.paging?.totalCount,
                  current: dataSearch.paging.pageIndex,
                  responsive: true,
                  pageSizeOptions: [10, 25, 50, 100],
                  position: ['topRight', 'bottomRight'],
                  style: { margin: '10px 0' },
                  showTotal: (total, range) => `Hiển thị ${range[0]}-${range[1]} của ${total} mục`,
                  onChange: (page, pageSize) => {
                    setDataSearch({
                      ...dataSearch,
                      paging: { ...dataSearch.paging, pageIndex: page, pageSize: pageSize },
                    });
                  },
                }}
              />
            </div>
          </div>
        </div>
      </>
    );
  });
};

export default createRoutingOrTransfer;
